import script from "./WalkthroughDrawerPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalkthroughDrawerPanel.vue?vue&type=script&setup=true&lang=ts"

import "./WalkthroughDrawerPanel.vue?vue&type=style&index=0&id=6c60170b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c60170b"]])

export default __exports__